module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info),
      expression: "!info"
    }],
    staticClass: "call",
    style: ({
      height: _vm.height + 'px',
      width: _vm.width + 'px'
    })
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.profile,
      "alt": "Berny"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\tBerny belt...\n\t\t")]), _vm._v(" "), _c('button', {
    class: {
      button: _vm.button, answered: _vm.answered
    },
    attrs: {
      "aria-label": _vm.answered ? 'Ophangen' : 'Opnemen'
    },
    on: {
      "click": _vm.answer
    }
  }, [_c('svg', {
    attrs: {
      "aria-hidden": "true",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 30 30",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.225 17.89c-.406-.24-.905-.234-1.31.006l-2.045 1.22c-.458.272-1.03.24-1.45-.088-.726-.567-1.895-1.52-2.912-2.538-1.017-1.017-1.97-2.186-2.538-2.912-.328-.42-.36-.992-.087-1.45l1.22-2.046c.24-.404.242-.907.004-1.313L9.105 3.64c-.29-.495-.87-.74-1.428-.602-.543.132-1.248.454-1.987 1.194-2.314 2.314-3.543 6.217 5.16 14.92s12.603 7.473 14.918 5.158c.74-.74 1.062-1.447 1.195-1.99.135-.56-.105-1.133-.6-1.423l-5.138-3.008z"
    }
  })])]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.answered),
      expression: "answered"
    }],
    ref: "video",
    staticClass: "video",
    class: {
      show: _vm.answered
    },
    attrs: {
      "id": "bgvid",
      "playsinline": ""
    },
    on: {
      "ended": _vm.onEnded
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info && !_vm.landscape),
      expression: "info && !landscape"
    }],
    staticClass: "info",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('svg', {
    attrs: {
      "aria-hidden": "true",
      "id": "Laag_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "200",
      "height": "200",
      "viewBox": "0 0 400 400"
    }
  }, [_c('path', {
    staticClass: "svg",
    attrs: {
      "d": "M145.3 168v-56c0-5.5 4.5-10 10-10h181c5.5 0 10 4.5 10 10v127.5c0 5.5-4.5 10-10 10h-95M241.2 231.5h104"
    }
  }), _c('path', {
    staticClass: "svg",
    attrs: {
      "d": "M217.7 297.5l-154 .5c-5.5 0-10-4.5-10-10v-95c0-5.5 4.5-10 10-10l154-.5c5.5 0 10 4.5 10 10v95c0 5.5-4.4 10-10 10zM266.8 259l10.9 38.5M286.8 297.5h-45.6M206.8 297.3V183.2M71.3 297.3V183.2M62.8 236.8v6.9"
    }
  }), _c('circle', {
    staticClass: "st1",
    attrs: {
      "fill": "#FFFFFF",
      "cx": "217.3",
      "cy": "240.2",
      "r": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "paragraph"
  }, [_vm._v("Gebruik je tablet of laptop om de site te kunnen bekijken.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.landscape),
      expression: "landscape"
    }],
    staticClass: "landscape"
  }, [_c('svg', {
    attrs: {
      "aria-hidden": "true",
      "id": "Laag_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "117",
      "height": "117",
      "viewBox": "0 0 234 234"
    }
  }, [_c('path', {
    staticClass: "svg",
    attrs: {
      "d": "M109.6 176H60.1c-5.5 0-10-4.5-10-10V68c0-5.5 4.5-10 10-10h49.5c5.5 0 10 4.5 10 10v98c0 5.5-4.5 10-10 10zM51.1 74.5h68M51.1 159.5h68M131.9 106.5h42c5.5 0 10 4.5 10 10V166c0 5.5-4.5 10-10 10h-42M167.4 107.5v68M130.9 59.8c17.7 0 30.5 11.6 30.5 30.5"
    }
  }), _c('path', {
    staticClass: "svg",
    attrs: {
      "d": "M169.1 86l-7 8.5-8.5-7"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "paragraph"
  }, [_vm._v("Draai je scherm")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cd2350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/Mobile.vue
// module id = 710
// module chunks = 64